import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext } from "@tanstack/react-router";
import { MainLayout } from "../app/components/app/mainLayout";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()(
  {
    component: MainLayout,
  },
);
